import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { FormGroup, Validators, FormBuilder } from '@angular/forms';

import { Response } from "@angular/http";

import { CustomValidators } from 'ng2-validation';

import { UserService } from './users.service';

import { DropdownValue } from '../shared/dropdown.model';

import { TreeSelectionModel } from '../shared/tree-selection.model';

import { FilterItemsService } from '../shared/filter-items.service';
import { FormHelperService } from "../core/services/form-helper.service";

@Component({
    selector: 'user-modal',
    moduleId: module.id,
    templateUrl: 'user-modal.component.html'
})
export class UserModalComponent implements OnInit {
    userFrom: FormGroup;
    displayUserTypePrefix: boolean = true;
    userTypeId: number = 1;
    headerText: string = "Create User";
    defaultUserTypeSelection: DropdownValue;
    showDuplicateError: boolean = false;
    private userId: number = 0;
    values: Array<TreeSelectionModel> = new Array<TreeSelectionModel>();

    @Output()
    public userChanged: EventEmitter<any> = new EventEmitter<Event>();;

    constructor(private userService: UserService, private filterItemsService: FilterItemsService, private formBuilder: FormBuilder, private formHelperService: FormHelperService) {
    }

    ngOnInit() {
        this.userFrom = this.formBuilder.group({
            firstN: ['', [Validators.required]],
            lastN: ['', [Validators.required]],
            email: ['', [Validators.required, CustomValidators.email]]
        });

        this.values = this.filterItemsService.getPublishers();
    }

    onSaveChanges(event: any) {
        if (!this.userFrom.valid) { return; };

        if (this.userTypeId === 2 && this.getSelectedPublishers().length === 0)
            return;

        if (this.userId === 0)
            this.userService.createUser(this.userFrom.value.firstN, this.userFrom.value.lastN, this.userFrom.value.email, this.userTypeId).subscribe((response) => {
                this.userChanged.emit();
                // must send user id from post response for the newly created user
                this.userService.updatePublishers(this.getSelectedPublishers(), response['id']).subscribe();
                $('#userModal').modal('hide');
            }, (error: Response) => {
                if (error.status === 400)
                    this.showDuplicateError = true;
            });
        else
            this.userService.updateUser(this.userId, this.userFrom.value.firstN, this.userFrom.value.lastN, this.userFrom.value.email, this.userTypeId).subscribe(() => {
                this.userChanged.emit();
                this.userService.updatePublishers(this.getSelectedPublishers(), this.userId).subscribe();
                $('#userModal').modal('hide');
            }, (error: any) => {
                if (error.status === 400)
                    this.showDuplicateError = true;
            });
    }

    onUserTypeChanged(item) {
        this.userTypeId = item.value;
    }

    showCreateUser() {
        this.headerText = "Create User";
        this.userId = 0;
        this.userTypeId = 1;
        this.userFrom.reset();
        this.defaultUserTypeSelection = new DropdownValue(1, 'SambaAdmin');
        //workaround to unselect all publishers when creating new user
        $("#publishers-select-assignement").next().find("[class='select-all-container']").children('span').eq(1).click();
        $('#userModal').modal('show');
    }

    showEditUser(event, item) {
        event.preventDefault();
        event.stopPropagation();
        this.headerText = "Edit User";
        this.userFrom.controls["firstN"].setValue(item.firstName);
        this.userFrom.controls["lastN"].setValue(item.lastName);
        this.userFrom.controls["email"].setValue(item.email);
        this.defaultUserTypeSelection = new DropdownValue(item.userTypeId, '');
        this.userId = item.id;
        this.userTypeId = item.userTypeId;
        //workaround to unselect all publishers when creating new user
        $("#publishers-select-assignement").next().find("[class='select-all-container']").children('span').eq(1).click();

        //workaroud to select publishers that user already has set
        if (this.userTypeId === 2) {
            this.userService.getAvailablePublisherIds(item.id).subscribe((response: Response) => {
                let ids = response.json();
                for (let id of ids) {
                    let filter = "div[data-value='" + id + "'][class='item']"
                    var item = $("#publishers-select-assignement").next().find("[class='selections']").find(filter);
                    if ($(item).data("value") === id)
                        $(item).children().eq(0).click();
                }
                $('#userModal').modal('show');
            });
        }
        else
            $('#userModal').modal('show');
    }

    showErrorMessage(controlName: string, validator: string): boolean {
        return this.formHelperService.showErrorMessage(this.userFrom, controlName, validator)
    }

    private getSelectedPublishers(): Array<number> {
        let items = $("#publishers-select-assignement").next().find("[class='selected']").find("[class='item']");
        let result = Array<number>();
        if (items)
            for (var i = 0; i < items.length; i++) {
                result.push($(items[i]).data("value"));
            }
        return result;
    }
}


// WEBPACK FOOTER //
// ./src/app/users/user-modal.component.ts